export default "__VITE_ASSET__BlRKPuMN__"